import { withWizardRefetch } from "../withWizardRefetch.js";
import { useRulesBox_QuestionControlForm_ModifyWizardSettingsMutation } from "./RulesBox.generated.js";

export const useRulesBox_QuestionControlForm_ModifyWizardSettingsMutationWithWizardRefetch =
  withWizardRefetch(
    useRulesBox_QuestionControlForm_ModifyWizardSettingsMutation
  );
